import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 0px 4px 0px #00000040',
    borderRadius: '10px',
    padding: '20px',
    gap: '15px',
    width: '100%',
  },
  studentCard: {
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 0px 4px 0px #00000040',
    borderRadius: '10px',
    padding: '20px',
    gap: '15px',
    width: 'clamp(290px, 38.02vw, 309px)',
    [theme.breakpoints.down(768)]: {
      width: '100%',
    },
  },
  cardTitleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  cardTitle: {
    fontSize: 'clamp(14px, 2.13vw, 20px)',
    fontWeight: 700,
    color: theme.palette.secondary.main,
    fontFamily: 'Montserrat',
  },
  cardSubtitle: {
    fontSize: '14px',
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontFamily: 'Montserrat',
  },
  cardButtonsContainer: {
    display: 'flex',
    gap: '15px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: '10px',
    },
  },
  cardButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
    padding: '4px 10px',
    fontSize: '13px',
    borderRadius: '5px',
    fontWeight: 500,
    textTransform: 'none',
  },
  innerSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  innerSectionIcon: {
    fontSize: '20px',
    color: theme.palette.text.primary,
  },
  innerSectionTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 'clamp(13px, 3.59vw, 14px)',
    color: theme.palette.text.primary,
  },
  innerSectionText: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
  priceContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  originalPrice: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: 'clamp(13px, 3.59vw, 14px)',
    lineHeight: '100%',
    verticalAlign: 'middle',
    textDecoration: 'line-through',
    color: theme.palette.text.primary,
  },
  discountPrice: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 'clamp(13px, 3.59vw, 14px)',
    lineHeight: '100%',
    verticalAlign: 'middle',
    color: theme.palette.text.primary,
  },
  programFinalPrice: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: 'clamp(23px, 6.41vw, 25px)',
    verticalAlign: 'middle',
    color: theme.palette.text.primary,
  },
  assignSection: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'end',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'start',
      gap: '10px',
    },
  },
  // Discounts styles
  inputCurrency: {
    '& .MuiInputBase-input': {
      fontSize: 'clamp(12px, 1.67vw, 16px)',
      fontFamily: 'Montserrat',
      paddingTop: '8px',
      paddingBottom: '8px',
    },
    '& .MuiSelect-select': {
      fontSize: 'clamp(12px, 1.67vw, 16px)',
      fontFamily: 'Montserrat',
      paddingTop: '8px',
      paddingBottom: '8px',
    },
    '& .MuiInputLabel-root': {
      top: '50%',
      transform: 'translate(14px, -50%)',
      '&.MuiInputLabel-shrink': {
        top: 0,
        transform: 'translate(14px, -9px) scale(0.75)',
      },
    },
    '& .MuiInputAdornment-root': {
      '& p': {
        fontSize: 'clamp(12px, 1.67vw, 16px)',
        fontFamily: 'Montserrat',
        fontWeight: 500,
        color: theme.palette.primary.main,
      },
    },
  },
  discountsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  paymentMethodsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '7px',
  },
  paymentMethodItem: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiCheckbox-root': {
      height: '18px',
      width: '18px',
      marginRight: '5px',
    },
  },
  paymentMethodLabel: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: 'clamp(8px, 1.04vw, 14px)',
    color: theme.palette.text.primary,
  },
  commentsButton: {
    fontWeight: 500,
    fontSize: 'clamp(14px, 2.13vw, 20px)',
    textTransform: 'none',
    border: '1px solid #2C82B3',
    width: '100%',
    padding: '14px 10px',
    lineHeight: '100%',
    [theme.breakpoints.down('md')]: {
      lineHeight: '80%',
      padding: '10px 10px',
      '& .MuiSvgIcon-root': {
        fontSize: '16px',
      },
    },
  },
  fullWidthButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.white,
    padding: '13px 10px',
    fontSize: 'clamp(14px, 2.13vw, 20px)',
    borderRadius: '5px',
    fontWeight: 500,
    textTransform: 'none',
    lineHeight: '120%',
    [theme.breakpoints.down('md')]: {
      lineHeight: '100%',
    },
  },
  // StudyPlan styles
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  studentMainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    justifyContent: 'center',
  },
  programsStudentContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    justifyContent: 'center',
    '& > *': {
      flex: '0 0 calc(25% - 15px)',
      minWidth: '319px',
      maxWidth: 'calc(25% - 15px)',
      [theme.breakpoints.down(715)]: {
        flex: '0 0 100%',
        minWidth: '100%',
        maxWidth: '100%',
      },
    },
  },
  commentButtonStudentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    alignItems: 'center',
    '& > *': {
      minWidth: '319px',
      maxWidth: 'calc(25% - 15px)',
      [theme.breakpoints.down(715)]: {
        flex: '0 0 100%',
        minWidth: '100%',
        maxWidth: '100%',
      },
    },
  },

  mainContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  relevantInfoContainer: {
    display: 'flex',
    gap: '20px',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  leftSide: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    flex: 1,
  },
  rightSide: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '411px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },

  addStudyPlanContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'space-between',
    [theme.breakpoints.down(768)]: {
      flexDirection: 'column',
      gap: '20px',
    },
  },
  addStudyPlanTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  createStudyPlanButton: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: 'clamp(8px, 1.04vw, 21px)',
    width: 'clamp(118px, 15.31vw, 314px)',
    height: 'clamp(20px, 2.60vw, 53px)',
    textTransform: 'none',
    alignSelf: 'center',
    padding: 0,
    [theme.breakpoints.down(768)]: {
      alignSelf: 'flex-start',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 'clamp(8px, 1.04vw, 21px)',
    },
  },
  text: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: 'clamp(8px, 1.04vw, 21px)',
  },
  strong: {
    fontWeight: 700,
    color: theme.palette.primary.main,
  },
  termsText: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '16px',
    color: theme.palette.text.primary,
  },
  termsTextContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  // Acción secundaria bajo el botón principal de la card de descuentos.
  secondaryFullWidthButton: {
    padding: '13px 10px',
    fontSize: 'clamp(14px, 2.13vw, 20px)',
    borderRadius: '5px',
    fontWeight: 500,
    textTransform: 'none',
    lineHeight: '120%',
    [theme.breakpoints.down('md')]: {
      lineHeight: '100%',
    },
  },
  // Card informativa (fondo celeste) usada para avisos del plan de estudios.
  infoCard: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: '#E3F2FD',
    border: '1px solid #90CAF9',
    borderRadius: '8px',
    padding: '16px 20px',
  },
  infoCardIcon: {
    color: '#0D47A1',
    flexShrink: 0,
  },
  infoCardText: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '150%',
    color: '#0D47A1',
  },
  infoCardLink: {
    fontWeight: 700,
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  // Mensajes de trazabilidad bajo el botón "Enviar Plan de Estudios".
  planStatusMessage: {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '140%',
    color: theme.palette.text.primary,
    marginTop: '10px',
    textAlign: 'center',
  },
  termsTextLink: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

export default useStyles;
